import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";



export function useFacilitiesApi() {
  const callApi = useApiCall();

  const getFacilityList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.GET_FACILITY_LIST, data, onSuccess, onError);
  };
  const getFacilityDetails = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.GET_FACILITY_DETAILS, data, onSuccess, onError);
  };

  const saveFacility = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.SAVE_FACILITY, data, onSuccess, onError);
  };
  const saveFacilityMaster = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.SAVE_FACILITY_MASTER, data, onSuccess, onError);
  };
  const saveTeam = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.SAVE_TEAM, data, onSuccess, onError);
  };
  const saveDepartment = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.SAVE_DEPARTMENT, data, onSuccess, onError);
  };
  const saveServiceTechMaster = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.SAVE_SERVICE_TECH_MASTER, data, onSuccess, onError);
  };
  const deleteFacility = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.DELETE_FACILITY, data, onSuccess, onError);
  };

  const getProcessingFacilityList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.GET_PROCESSING_FACILITY_LIST, data, onSuccess, onError);
  };

  const getFacilityCode = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.GET_FACILITY_CODE, data, onSuccess, onError);
  };

  const getSubFacilityList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.GET_SUB_FACILITY_LIST, data, onSuccess, onError);
  };

  const saveSubFacility = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.SAVE_SUB_FACILITY, data, onSuccess, onError);
  };


  const getSubFacilityTypeList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.GET_SUB_FACILITY_TYPE_LIST, data, onSuccess, onError);
  };


  const SaveSubFacilityImage = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.SAVE_SUB_FACILITY_IMAGE, data, onSuccess, onError);
  };

  const SaveFacilityImage = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.SAVE_FACILITY_IMAGE, data, onSuccess, onError);
  };

  const Exportcsv = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.EXPORT_TO_CSV, data, onSuccess, onError);
  }
  const Exportpdf = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.EXPORT_TO_PDF, data, onSuccess, onError);
  }
  const ExportQrCode = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.EXPORT_QR_CODE, data, onSuccess, onError);
  }
  const getFacilityManagerList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.GET_FACILITY_MANAGER_LIST, data, onSuccess, onError);
  };
  
  const deleteFacilityManager = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.DELETE_FACILITY_MANAGER, data, onSuccess, onError);
  };

  const deleteServiceTech = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.DELETE_SERVICE_TECH, data, onSuccess, onError);
  };

  const getFacilityActivity = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.GET_FACILITY_ACTIVITY, data, onSuccess, onError);
  };

  const updateFacilityActivityLogStatus = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.UPDATE_FACILITY_ACTIVITY_LOG_STATUS, data, onSuccess, onError);
  };

  const deleteFacilityActivityLog = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.FACILITY.DELETE_FACILITY_ACTIVITY_LOG, data, onSuccess, onError);
  };


  return {
    getFacilityList,
    getFacilityDetails,
    saveFacility,
    saveFacilityMaster,
    saveTeam,
    saveDepartment,
    saveServiceTechMaster,
    deleteFacility,
    getProcessingFacilityList,
    getFacilityCode,
    getSubFacilityList,
    saveSubFacility,
    getSubFacilityTypeList,
    SaveSubFacilityImage,
    SaveFacilityImage,
    
    Exportcsv,
    Exportpdf,
    ExportQrCode,
    getFacilityManagerList,
    deleteFacilityManager,
    deleteServiceTech,
    getFacilityActivity,
    updateFacilityActivityLogStatus,
    deleteFacilityActivityLog
  };
}
